<template>
  <div class="popup-background d-flex align-items-center">
    <div class="popup-data">
      <div class="icon-container" @click="toggleDiagnostics">
        <font-awesome-icon icon="times"></font-awesome-icon>
      </div>
      <div class="popup-header d-flex flex-column justify-content-center align-items-center">
        <span class="studies-found">{{data.total_studies}} studies found</span>
        <span class="studies-errors mt-2"> {{data.anomalies_count}} studies with anomalies</span>
      </div>
      <div class="popup-details d-flex flex-column align-items-center" v-if="Number.isInteger(detailsToggled)">
        <div class="diagnostic-toggle" @click="showDiagnostic = !showDiagnostic">{{`${showDiagnostic ? 'HIDE' : 'SHOW'}
          DIAGNOSTICS`}}
        </div>
        <template v-if="!showDiagnostic">
          <template v-if="data.anomalies[detailsToggled].reports.length">
            <div class="d-flex">
              <span>Details for</span>
              <router-link class="ml-2" :to="{name: 'study-details', params: { id: data.anomalies[detailsToggled].study_id }}"
                           target="_blank">
                {{data.anomalies[detailsToggled].c_mi_number}}
              </router-link>
              <span>:</span>
            </div>
            <div class="study-error-list d-flex flex-column mb-4">
              <div v-for="(log, index) in data.anomalies[detailsToggled].reports" class="d-flex mt-1"
                   :key="`${log.type}-${index}`"
                   :class="{'red': log.type === 'error', 'orange': log.type === 'warning', 'green': log.type === 'info'}">
                <font-awesome-icon class="icon"
                                   :icon="log.type === 'error' ? 'times-circle' : log.type === 'warning' ? 'exclamation-circle' : 'check-circle'"></font-awesome-icon>
                <span class="ml-2">{{log.message}}</span>
              </div>
            </div>
          </template>
          <div v-for="log in data.anomalies[detailsToggled].result_files" :key="log.filename"
               class="d-flex flex-column align-items-center">
            <span>In file {{log.filename}}:</span>
            <div v-for="(value, index) in log.entries" class="file-error-list d-flex mt-1"
                 :key="`${value.type}-${index}`"
                 :class="{'red': value.type === 'error', 'orange': value.type === 'warning', 'green': value.type === 'info'}">
              <font-awesome-icon class="icon"
                                 :icon="value.type === 'error' ? 'times-circle' : value.type === 'warning' ? 'exclamation-circle' : 'check-circle'"></font-awesome-icon>
              <span class="ml-2">{{value.message}}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="diagnostic-container">
              <!--            <vue-json-pretty-->
              <!--                :data="data.anomalies[detailsToggled]">-->
              <!--            </vue-json-pretty>-->
              <!--           TODO ADD JSON VIEWER  -->
          </div>
        </template>
      </div>
    </div>
    <div class="studies-wrapper">
      <div v-for="(value, index) in data.anomalies" :key="value.c_mi_number"
           class="study-container py-3 d-flex justify-content-between align-items-center"
           :class="{active: detailsToggled === index}" @click="detailsToggled = index">
        <span class="study-title">{{value.c_mi_number}}</span>
        <div class="study-logs d-flex">
          <span class="study-errors">{{value.errors}} errors</span>
          <span class="mx-1">/</span>
          <span class="study-warnings">{{value.warnings}} warnings</span>
          <span class="mx-1">/</span>
          <span class="study-infos">{{value.infos}} infos</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiagnosticsPopup',
  props: {
    data: Object,
    toggleDiagnostics: Function
  },
  data () {
    return {
      detailsToggled: null,
      showDiagnostic: false
    }
  }
}
</script>

<style scoped>
.popup-background {
  background-color: white;
  height: calc(100% - 105px);
}

.studies-wrapper {
  overflow: scroll;
  width: 40%;
  height: 100%;
  font-size: 24px;
  border-left: 1px solid #d1d4d7;
}

.studies-wrapper .study-container:last-of-type {
  border-bottom: 0;
}

.popup-data {
  width: 60%;
  height: 100%;
  font-size: 26px;
}

.popup-header {
  height: 138px;
  border-bottom: 1px solid #d1d4d7;
}

.study-container {
  cursor: pointer;
  padding: 0 20px;
  border-bottom: 1px solid #d1d4d7;
  width: 100%;
}

.popup-details {
  position: relative;
  padding: 1rem;
  height: calc(100% - 138px);
  overflow-y: scroll;
}

.studies-found {
  color: #2d884d;
}

.studies-errors {
  color: #b34045;
}

.study-errors {
  color: #b34045;
}

.study-warnings {
  color: #fecf6d;
}

.study-infos {
  color: #2d884d;
}

.study-logs {
  font-size: 20px;
}

.study-error-list {
  font-size: 20px;
  width: 700px;
}

.file-error-list {
  width: 700px;
  font-size: 20px;
}

.green {
  color: #2d884d;
}

.orange {
  color: #fecf6d;
}

.red {
  color: #b34045;
}

.icon-container {
  cursor: pointer;
  position: absolute;
  top: 10px;
  left: 20px;
}

.active {
  background-color: #eeeeee;
}

.icon {
  margin-top: 5px;
}

.diagnostic-toggle {
  z-index: 5;
  cursor: pointer;
  font-size: 12px;
  position: absolute;
  right: 10px;
  top: 10px;
  transition: color 0.1s linear;
}

.diagnostic-toggle:hover {
  color: #20a8d8
}

.diagnostic-container {
  width: 100%;
  overflow-x: scroll;
}
</style>
